import(/* webpackMode: "eager" */ "/home/interim/frontend/app/services/temporary-staff/page.tsx");
